import FootballStatsCategory from "../../../stats/football-stats-category";
import DriveService from "../../../../../services/drive-service";
import FootballState from "../../../state/football-state";
import PatComplete from "./pat-complete";
import StatsRule from "../../../../common/stats-rule";

export default class PatCompleteStats extends StatsRule {
    static _resolvePatStatsFragmentAndPoints(play, fragment, gameContext) {
        if (PatComplete.ruleApplies(fragment, play, gameContext)) {
            const statsFragment =
                play.getFirstFragment(FootballState.FieldGoalFakeRun) ||
                play.getFirstFragment(FootballState.FieldGoalFakePass) ||
                play.getFirstFragment(FootballState.PatPass) ||
                play.getFirstFragment(FootballState.Run) ||
                play.getFirstFragment(FootballState.PatKick);

            const points = statsFragment.getScoringPoints(
                gameContext.gameConfig
            );

            const player =
                statsFragment.passedBy ||
                statsFragment.runBy ||
                statsFragment.rushedBy ||
                statsFragment.kickedBy;

            return { statsFragment, points, player };
        }

        return {};
    }

    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            PatComplete.ruleApplies(fragment, play, gameContext) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { statsFragment, points, player } =
            PatCompleteStats._resolvePatStatsFragmentAndPoints(
                play,
                fragment,
                gameContext
            );

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            playerId: player.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: statsFragment.id,
            category: FootballStatsCategory.PAT_COMPLETE,
            values: { points }
        });
    }

    switchPossession() {}
}
